// extracted by mini-css-extract-plugin
export default {"title":"Ls1Fy5","text":"OH22hJ","container":"AoWkkb","container--mobile":"NT9O0k","wrapper":"DGHo_P","interactiveBlock":"b3jbYK"};